// This is only a presentation adapter. It neither validates a transaction nor
// changes membership failure/success semantics.
const fields = new Set(['nodeId', 'nodeName', 'orgType', 'orgTypeCustom',
  'adminName', 'companyEmail', 'companyPhone', 'location', 'locationCustom', 'endpoint']);
const legacyFields: Record<string, string> = {
  '노드 ID는 필수입니다': 'nodeId',
  '노드 ID는 3-20자의 영문자, 숫자, 언더스코어만 허용됩니다': 'nodeId',
  '이메일은 필수입니다': 'companyEmail',
  '올바른 이메일 형식을 입력하세요': 'companyEmail',
  '올바른 이메일 형식을 입력하세요 (예: company@example.com)': 'companyEmail',
  '전화번호는 필수입니다': 'companyPhone',
  '올바른 전화번호 형식을 입력하세요': 'companyPhone',
  '올바른 전화번호 형식을 입력하세요 (예: 010-1234-5678, 051-123-4567)': 'companyPhone',
  '올바른 엔드포인트 URL을 입력하세요': 'endpoint',
  '엔드포인트는 http://domain:port 형식이어야 합니다 (예: http://example.com:7051)': 'endpoint',
  '노드 이름은 1-50자여야 합니다': 'nodeName',
  '조직 유형은 필수입니다': 'orgType',
  'Inje University 이름은 필수입니다': 'adminName',
  '위치는 필수입니다': 'location'
};
export function validationFieldMessages(response: any): Record<string, string> {
  const result: Record<string, string> = {};
  for (const item of Array.isArray(response?.validationDetails) ? response.validationDetails : []) {
    if (item && fields.has(item.field)) result[item.field] = typeof item.message === 'string' ? item.message : 'Please check this field.';
  }
  for (const item of Array.isArray(response?.validationErrors) ? response.validationErrors : []) {
    if (item && typeof item === 'object' && fields.has(item.field)) {
      result[item.field] = typeof item.message === 'string' ? item.message : 'Please check this field.';
    } else if (typeof item === 'string' && legacyFields[item]) {
      result[legacyFields[item]] = item;
    }
  }
  return result;
}
